import {
  PromotionCreateBody,
  PromotionItem,
  PromotionDetailResponse,
} from "utils/api/client/types"

export class Promotion {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }
  create(
    vendorId: string,
    body: PromotionCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<PromotionItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/promotions-v2`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }

  update(
    id: string,
    vendorId: string,
    body: PromotionCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<PromotionItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/promotions-v2/${id}`,
        {
          method: "PUT",
          headers,
          body,
          query,
        }
      )
    })()
  }

  retrieve(
    id: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<PromotionDetailResponse> {
    return (async () => {
      const { vendorId, ...reset } = queryParams as any
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/promotions-v2/${id}`,
        {
          query: reset,
          headers,
        }
      )
    })()
  }

  delete(
    id: string,
    vendorId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/promotions-v2/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }

  duplicate(
    id: string,
    vendorId: string,
    body: { name: string },
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/promotions-v2/${id}/duplicate`,
        {
          method: "POST",
          headers,
          body,
        }
      )
    })()
  }
}
